import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { FiDownload } from "react-icons/fi";
import classnames from "classnames";

// helpers
import { ReportFormatters } from "../../../../utils/Reports/AccountingValidation/ReportFormatters";
import { GenerateReports } from "../../../../utils/Reports/AccountingValidation/GenerateReports";

// components
import { Page, Breadcrumbs, Form, Loading } from "components";

// styles
import "./styles.scss";

const BREADCRUMBS = [
  { name: "Home", to: "/" },
  { name: "Relatórios", to: "/reports" },
  { name: "Validação Contábil", to: "/report/accounting-validation" },
  { name: "Vouchers Utilizados", to: "" },
];

function UsedVouchers() {
  const [file, setFile] = useState();
  const [loading, setLoading] = useState(false);
  const { register, handleSubmit } = useForm();

  const onSubmit = async ({ analyticReport, usedVouchers }, event) => {
    setFile(undefined);
    setLoading(true);

    try {
      const formattedAnalyticReport = await ReportFormatters.analytic(
        analyticReport
      );

      const formattedUsedVouchers = await ReportFormatters.usedVouchers(
        usedVouchers
      );

      const blobFile = await GenerateReports.disagreementsUsedVoucher(
        formattedAnalyticReport,
        formattedUsedVouchers
      );

      setFile(blobFile);
    } catch (error) {
      alert("Error ao processar planilhas!");
      console.error(error);
    }

    event.target.reset();
    setLoading(false);
  };

  async function downloadReportFile() {
    let url = window.URL.createObjectURL(file);
    let a = document.createElement("a");
    a.href = url;
    a.download = "divergencia-vouchers-utilizados.xlsx";
    a.click();
  }

  return (
    <Page>
      <Breadcrumbs breadcrumbs={BREADCRUMBS} />
      <div id="accounting_validation_used_vouchers">
        <h3>Vouchers Utilizados</h3>

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="input-container">
            <Form.Label htmlFor="analytic">
              Relatório Analítico (Motor Fidelidade)
            </Form.Label>
            <input
              {...register("analyticReport")}
              type="file"
              id="analytic"
              accept=".xlsx, .xls"
              required
            />
          </div>

          <div className="input-container">
            <Form.Label htmlFor="usedVoucher">
              Relatório de Vouchers (CAR - Contábil)
            </Form.Label>
            <input
              {...register("usedVouchers")}
              type="file"
              id="usedVoucher"
              accept=".xlsx, .xls"
              required
            />
          </div>

          <Form.Button
            type="submit"
            className={classnames({ disable: loading })}
          >
            Processar
          </Form.Button>
        </form>

        <div className={"download-container"}>
          {loading ? (
            <Loading />
          ) : (
            <button
              type="button"
              className={classnames({ active: file })}
              onClick={file && downloadReportFile}
            >
              <FiDownload />
            </button>
          )}
        </div>
      </div>
    </Page>
  );
}

export default UsedVouchers;
